/**
 * Departments Services Module
 * Exports all department management services and factory functions
 */
// Service exports
export * from './DepartmentService';
export * from './DesignationService';
export * from './DesignationTaskService';
export * from './MemberDesignationService';
export * from './MemberInDepartmentService';
export * from './MinistryService';
export * from './MinistryActivityService';
export * from './MinistryEquipmentService';
export * from './MinistryRoleService';
export * from './MinistryTeamService';
// Service imports for factory
import { DepartmentService } from './DepartmentService';
import { DesignationService } from './DesignationService';
import { DesignationTaskService } from './DesignationTaskService';
import { MemberDesignationService } from './MemberDesignationService';
import { MemberInDepartmentService } from './MemberInDepartmentService';
import { MinistryService } from './MinistryService';
import { MinistryActivityService } from './MinistryActivityService';
import { MinistryEquipmentService } from './MinistryEquipmentService';
import { MinistryRoleService } from './MinistryRoleService';
import { MinistryTeamService } from './MinistryTeamService';
/**
 * Create all departments services with shared configuration
 * @param http - HTTP client instance
 * @param config - Service configuration (servicePath, endpoints)
 * @returns Object containing all departments service instances
 */
export function createDepartmentsServices(http, config) {
    return {
        department: new DepartmentService(http, config),
        designation: new DesignationService(http, config),
        designationTask: new DesignationTaskService(http, config),
        memberDesignation: new MemberDesignationService(http, config),
        memberInDepartment: new MemberInDepartmentService(http, config),
        ministry: new MinistryService(http, config),
        ministryActivity: new MinistryActivityService(http, config),
        ministryEquipment: new MinistryEquipmentService(http, config),
        ministryRole: new MinistryRoleService(http, config),
        ministryTeam: new MinistryTeamService(http, config),
    };
}
//# sourceMappingURL=index.js.map